<template>
  <header>
    <div class="flex">
      <div class="step" :class="{ done: step > 1, active: step == 1, inactive: step != 1 }">
        <div class="number">
          <div class="circle">
            <i class="material-icons">done</i>
            <p>1</p>
          </div>
        </div>
        <h6>Wybierz pakiet</h6>
      </div>
      <div class="step-line"></div>
      <div class="step" :class="{ done: step > 2, active: step == 2, inactive: step != 2 }">
          <div class="number">
          <div class="circle">
            <i class="material-icons">done</i>
            <p>2</p>
          </div>
        </div>
        <h6>Wypełnij formularz</h6>
      </div>
      <div class="step-line"></div>
      <div class="step" :class="{ done: step > 3, active: step == 3, inactive: step != 3 }">
          <div class="number">
          <div class="circle">
            <i class="material-icons">done</i>
            <p>3</p>
          </div>
        </div>
        <h6>Podsumowanie</h6>
      </div>
      <div class="step-line"></div>
      <div class="step" :class="{ done: step > 4, active: step == 4, inactive: step != 4 }">
          <div class="number">
          <div class="circle">
            <i class="material-icons">done</i>
            <p>4</p>
          </div>
        </div>
        <h6>Zapłać</h6>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'OrderHeader',
  data() {
    return{
     
    }
  },
  props:{
    step: Number,
  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
  div.flex { display: flex; flex-wrap: nowrap; justify-content: center; }
  div.step.active div.number div.circle { border-color: $orangeDark; }
  div.step.active div.number div.circle p { color: $orangeDark; }
  div.step.active h6 { color: $orangeDark; }
  div.step i.material-icons { display: none; color: $grayLight; }
  div.step.done p { display: none; }
  div.step.done i.material-icons { display: block; color: $orangeDark; }

  @media (max-width: 850px) {
    div.step.inactive { display: none; }
  }
</style>
